import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { RecentExpenseActivityEntity } from "../entities/RecentExpenseActivityEntity";
import type { GetRecentExpenseActivityParams } from "../repositories/ClientOverviewRepository";

export class GetRecentExpenseActivityUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(params: GetRecentExpenseActivityParams): Promise<RecentExpenseActivityEntity> {
    return this.repository.getRecentExpenseActivity(params);
  }
}
